import { render, staticRenderFns } from "./AlignCenter.vue?vue&type=template&id=e98fd9ca&"
import script from "./AlignCenter.vue?vue&type=script&lang=js&"
export * from "./AlignCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports